<div [formGroup]="form">
    <mat-form-field *ngIf="changeConditionClass" appearance="fill" class="w-full">
        <mat-label>Clase de Condición de Cambio</mat-label>
        <mat-select formControlName="changeConditionClassId" placeholder="Seleccione una clase de Condición de Cambio">

            <!-- <mat-option *ngFor="let changeConditionClass of changeConditionClassList" [value]="changeConditionClass._id">
                {{ changeConditionClass.name }}
            </mat-option> -->
            <mat-option [value]="null">Ninguno</mat-option>
            <mat-option *ngFor="let cls of changeConditionClassList" [value]="cls.value">
                {{cls.label}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="changeConditionType" appearance="fill" class="w-full">
        <mat-label>Tipo de Condición de Cambio</mat-label>
        <mat-select formControlName="changeConditionTypeId" placeholder="Seleccione un tipo de Condición de Cambio"
            multiple>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchChangeConditionType" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar tipos de Condición de Cambio..."
                    noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterChangeConditionType($event)">
                </ngx-mat-select-search>
            </mat-option>

            <!-- <mat-option *ngFor="let changeConditionType of filteredChangeConditionTypeList" [value]="changeConditionType._id">
                {{ changeConditionType.name }}
            </mat-option> -->
            <mat-option *ngFor="let type of filteredChangeConditionTypeList" [value]="type.value">
                {{type.label}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>